import { Component, inject, HostListener, effect, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionMenuService } from '@/share/services/action-menu.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActionMenuItem } from '@/share/template/button/action-menu';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-action-menu-overlay',
    standalone: true,
    imports: [CommonModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
        @if (svc.isOpen()) {
            <div class="fixed z-[9999] bg-white dark:bg-neutral-900 shadow-lg rounded-md border dark-mode p-5 min-w-[180px]" [style.top.px]="svc.y()" [style.left.px]="svc.x()">
                @for (item of sanitizedItems; track item.action) {
                    <button type="button" class="flex items-center gap-2 w-full p-4 hover:bg-gray-100 dark:hover:bg-[var(--color-neutral-800)] cursor-pointer rounded-md" [class.text-red-500]="item.danger" (click)="onItemClick(item, $event)">
                        @if (item.icon) {
                            <i [class]="item.icon"></i>
                        }

                        @if (item.safeSvg) {
                            <span [innerHTML]="item.safeSvg"></span>
                        }

                        {{ item.label | translate }}
                    </button>
                }
            </div>
        }
    `
})
export class ActionMenuOverlay {
    svc = inject(ActionMenuService);
    private readonly sanitizer = inject(DomSanitizer);
    sanitizedItems: (ActionMenuItem & { safeSvg?: SafeHtml })[] = [];
    private skipClose = false; // ✅ flag

    constructor() {
        effect(() => {
            this.sanitizedItems = this.svc.items().map((item) => ({
                ...item,
                safeSvg: item.svg ? this.sanitizer.bypassSecurityTrustHtml(item.svg.replace(/stroke="#[0-9a-fA-F]{3,6}"/g, 'stroke="currentColor"').replace(/fill="#[0-9a-fA-F]{3,6}"/g, 'fill="currentColor"')) : undefined
            }));
        });
    }

    onItemClick(item: ActionMenuItem, event: MouseEvent): void {
        event.stopPropagation();
        this.skipClose = true;
        this.svc.emit(item.action);
    }

    @HostListener('document:click')
    onDocumentClick(): void {
        if (this.skipClose) {
            this.skipClose = false;
            return;
        }
        this.svc.close();
    }
}
